<template>
  <div>
    <!-- ===================== LIST ===================== -->
    <div v-if="view === 'list'">
      <div class="card mar-to-15" style="width: calc(100% - 20px); margin-left: 10px; margin-right: 10px;">
        <div class="card-content">
          <div class="text-right">
            <p>
              <button class="btn add" @click.prevent="openForm(null)">
                <img src="/static/img/icons/add.png">
                {{ $t('deliveryPreferences.slotAdd') }}
              </button>
            </p>
          </div>

          <div v-loading="loading">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th style="width:70px">ID</th>
                  <th>{{ $t('deliveryPreferences.numeAdmin') }}</th>
                  <th>{{ $t('deliveryPreferences.name') }}</th>
                  <th>{{ $t('deliveryPreferences.costPerParte') }}</th>
                  <th>{{ $t('deliveryPreferences.seats') }}</th>
                  <th style="width:130px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="slot in slots" :key="slot.id" style="cursor:pointer" @click="openForm(slot.id)">
                  <td>{{ slot.id }}</td>
                  <td>{{ slot.nume_admin }}</td>
                  <td>{{ slot.name }}</td>
                  <td>{{ slot.cost_per_parte !== null ? slot.cost_per_parte : '-' }}</td>
                  <td>{{ slot.seats ? slot.seats.length : 0 }}</td>
                  <td><div class="edit" style="white-space:nowrap;"><i class="fa fa-pencil"></i> {{ $t('general.edit') }}</div></td>
                </tr>
                <tr v-if="!loading && !slots.length">
                  <td colspan="6" class="text-center">{{ $t('deliveryPreferences.noData') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================== FORM ===================== -->
    <div v-else>
      <div class="settings-top-bar">
        <div class="top-bar">
          <p>
            <a class="btn btn-orange btn-icon back" @click.prevent="backToList">
              <i class="ti-arrow-left"></i> {{ $t('deliveryPreferences.back') }}
            </a>
          </p>
          <p class="d-inline-flex">
            <a v-if="model.id" class="btn btn-danger btn-icon delete mar-rt-10" style="padding: 7px 10px; margin-right: 20px;" @click.prevent="remove">
              <img src="/static/img/icons/icon-close.png"> {{ $t('general.delete') }}
            </a>
            <button class="btn btn-icon btn-success save mar-rt-10" @click.prevent="save">
              <img src="/static/img/icons/save.png"> {{ $t('general.save') }}
            </button>
          </p>
        </div>
      </div>

      <div class="row mar-to-15">
        <div class="col-lg-6 col-md-12">
          <div class="card" style="margin: 0 10px;">
            <div class="card-content" v-loading="loading">
              <p class="text-danger" v-if="formError">{{ formError }}</p>

              <div class="form-group">
                <label>{{ $t('deliveryPreferences.numeAdmin') }} *</label>
                <input type="text" class="form-control" :class="{'is-invalid': attemptedSave && !model.nume_admin}" v-model="model.nume_admin" :placeholder="$t('deliveryPreferences.numeAdminPlaceholder')">
              </div>

              <div class="form-group">
                <label>{{ $t('deliveryPreferences.name') }} *</label>
                <input type="text" class="form-control" :class="{'is-invalid': attemptedSave && !model.name}" v-model="model.name" :placeholder="$t('deliveryPreferences.name')">
              </div>

              <div class="form-group">
                <label>{{ $t('deliveryPreferences.costPerParte') }}</label>
                <input type="number" step="0.01" min="0" class="form-control" v-model.number="model.cost_per_parte" placeholder="—">
                <small class="text-muted">{{ $t('deliveryPreferences.costPerParteHelp') }}</small>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-12">
          <div class="card" style="margin: 0 10px;">
            <div class="card-content">
              <label>{{ $t('deliveryPreferences.seats') }}</label>
              <p><small class="text-muted">{{ $t('deliveryPreferences.seatsHelp') }}</small></p>

              <div v-if="model.seats.length" class="d-flex" style="display:flex; gap:10px; margin-bottom:5px;">
                <label style="width:270px; margin-right:10px; margin-bottom:0;">{{ $t('deliveryPreferences.seatsCount') }}</label>
                <label style="width:270px; margin-right:10px; margin-bottom:0;">{{ $t('deliveryPreferences.seatCost') }}</label>
                <span style="width:35px;"></span>
              </div>

              <div v-for="(seat, index) in model.seats" :key="index" class="d-flex align-items-center" style="display:flex; gap:10px; margin-bottom:10px;">
                <input type="number" min="0" step="1" class="form-control" style="width:270px; margin-right:10px;"
                       :class="{'is-invalid': attemptedSave && !isFilled(seat.numar)}"
                       v-model.number="seat.numar" :placeholder="$t('deliveryPreferences.seatsCount')">
                <input type="number" min="0" step="0.01" class="form-control" style="width:270px; margin-right:10px;"
                       :class="{'is-invalid': attemptedSave && !isFilled(seat.cost)}"
                       v-model.number="seat.cost" :placeholder="$t('deliveryPreferences.seatCost')">
                <button class="btn btn-sm btn-danger" style="width:35px; height:35px; padding:0;" @click.prevent="removeSeat(index)">
                  <i class="ti-close"></i>
                </button>
              </div>

              <button class="btn btn-sm btn-outline-primary" @click.prevent="addSeat">
                <i class="ti-plus"></i> {{ $t('deliveryPreferences.addSeatTier') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'

export default {
  data () {
    return {
      view: 'list',
      loading: true,
      attemptedSave: false,
      formError: '',
      slots: [],
      model: this.emptyModel()
    }
  },
  created () {
    this.getData()
  },
  methods: {
    sessionData (extra = {}) {
      return Object.assign({
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }, extra)
    },
    emptyModel () {
      return {
        id: null,
        nume_admin: '',
        name: '',
        cost_per_parte: null,
        seats: [{ numar: null, cost: null }]
      }
    },
    getData () {
      this.loading = true
      this.apiRequest('/delivery-slot', 'GET', this.sessionData(), (response) => {
        if (response.status === true) {
          this.slots = response.data
        }
        this.loading = false
      })
    },
    isFilled (v) {
      return v !== null && v !== '' && typeof v !== 'undefined' && !isNaN(v)
    },
    openForm (id) {
      this.formError = ''
      this.attemptedSave = false
      if (id) {
        const slot = this.slots.find(s => s.id === id)
        this.model = {
          id: slot.id,
          nume_admin: slot.nume_admin,
          name: slot.name,
          cost_per_parte: slot.cost_per_parte !== null ? Number(slot.cost_per_parte) : null,
          seats: (slot.seats || []).map(s => ({ id: s.id, numar: Number(s.numar), cost: Number(s.cost) }))
        }
        if (!this.model.seats.length) this.model.seats.push({ numar: null, cost: null })
      } else {
        this.model = this.emptyModel()
      }
      this.view = 'form'
    },
    backToList () {
      this.view = 'list'
      this.getData()
    },
    addSeat () {
      this.model.seats.push({ numar: null, cost: null })
    },
    removeSeat (index) {
      this.model.seats.splice(index, 1)
    },
    save () {
      this.attemptedSave = true
      const seatsFilled = this.model.seats.length && this.model.seats.every(s => this.isFilled(s.numar) && this.isFilled(s.cost))
      if (!this.model.nume_admin || !this.model.name || !seatsFilled) {
        this.formError = (!this.model.nume_admin || !this.model.name) ? this.$t('general.fillRequiredFields') : this.$t('deliveryPreferences.seatsRequired')
        return
      }
      this.formError = ''
      this.loading = true

      const payload = this.sessionData({
        nume_admin: this.model.nume_admin,
        name: this.model.name,
        cost_per_parte: (this.model.cost_per_parte === '' || this.model.cost_per_parte === null || isNaN(this.model.cost_per_parte)) ? null : this.model.cost_per_parte,
        seats: this.model.seats.map(s => ({
          id: s.id,
          numar: s.numar,
          cost: s.cost
        }))
      })

      const url = this.model.id ? '/delivery-slot/' + this.model.id : '/delivery-slot'
      const method = this.model.id ? 'PUT' : 'POST'

      this.apiRequest(url, method, payload, (response) => {
        this.loading = false
        if (response.success === true) {
          swal({ text: this.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1500 }).then(() => {}).catch(() => {})
          this.backToList()
        } else {
          this.formError = this.firstError(response.errors)
        }
      })
    },
    remove () {
      const self = this
      swal({
        title: self.$t('deliveryPreferences.deleteConfirm'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: self.$t('general.yes')
      }).then((result) => {
        if (result && (result.value || result === true)) {
          self.loading = true
          self.apiRequest('/delivery-slot/' + self.model.id, 'PUT', self.sessionData({ delete: true }), (response) => {
            self.loading = false
            if (response.success === true) {
              swal({ text: self.$t('deliveryPreferences.saved'), type: 'success', showConfirmButton: false, timer: 1500 }).then(() => {}).catch(() => {})
              self.backToList()
            } else {
              swal({ text: self.firstError(response.errors) || self.$t('validations.wentWrong'), type: 'error', showConfirmButton: false, timer: 2500 }).then(() => {}).catch(() => {})
            }
          })
        }
      }).catch(() => {})
    },
    firstError (errors) {
      if (!errors) return ''
      const keys = Object.keys(errors)
      if (!keys.length) return ''
      const v = errors[keys[0]]
      return Array.isArray(v) ? v[0] : v
    }
  }
}
</script>

<style scoped>
.form-control.is-invalid {
  border: 1px solid #dc3545 !important;
  background-color: #fff5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/DeliveryPreferences/SettingsDeliverySlots.vue